import { render } from "./ColorsView.vue?vue&type=template&id=f1de1bca&scoped=true"
import script from "./ColorsView.vue?vue&type=script&lang=js"
export * from "./ColorsView.vue?vue&type=script&lang=js"

import "./ColorsView.vue?vue&type=style&index=0&id=f1de1bca&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/fife-cz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1de1bca"]])

export default __exports__